import { colors } from "../shared/constants";

// Portal-local styles. Deliberately not imported from shared/styles.js: that
// module is shaped around the staff shell (240px sidebar, nav rows), and the
// portal must not grow a dependency on it. The palette is shared, the layout
// is not.

export const bmColors = {
  ...colors,
  // The staff login screen uses these literals rather than the palette, so the
  // portal matches them for a consistent front door.
  loginBg: "#2c3e50",
  action: "#c0392b",
};

// A definite height, not minHeight: the screens below scroll inside
// themselves — the padded content area and the booking board both — and a
// flex child cannot size its own overflow against a container that has no
// height to resolve against.
export const page = {
  height: "100vh",
  overflow: "hidden",
  backgroundColor: "#f1f5f9",
  display: "flex",
  flexDirection: "column",
};

export const topbar = (isMobile) => ({
  backgroundColor: colors.darkGrey,
  color: colors.white,
  padding: isMobile ? "12px 16px" : "16px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
});

export const tabBar = {
  display: "flex",
  backgroundColor: colors.white,
  borderBottom: `1px solid ${colors.border}`,
  overflowX: "auto",
};

export const tab = (active) => ({
  padding: "12px 18px",
  fontSize: "14px",
  fontWeight: active ? "600" : "400",
  color: active ? colors.activeBlue : "#666",
  borderBottom: active ? `3px solid ${colors.activeBlue}` : "3px solid transparent",
  background: "none",
  border: "none",
  cursor: "pointer",
  whiteSpace: "nowrap",
});

export const content = (isMobile) => ({
  flex: 1,
  padding: isMobile ? "12px" : "20px 24px",
  overflow: "auto",
});

export const card = {
  backgroundColor: colors.white,
  borderRadius: "12px",
  border: `1px solid ${colors.border}`,
  overflow: "hidden",
};

export const cardPad = {
  ...card,
  padding: "16px",
};

export const rowStyle = (hover) => ({
  padding: "12px 16px",
  borderBottom: `1px solid ${colors.border}`,
  backgroundColor: hover ? "#f8fafc" : colors.white,
  cursor: "pointer",
});

export const label = {
  fontSize: "11px",
  fontWeight: "700",
  color: colors.slate,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  marginBottom: "4px",
  display: "block",
};

export const input = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: "8px",
  border: `1px solid ${colors.border}`,
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
  backgroundColor: "#f8fafc",
};

export const primaryButton = (disabled) => ({
  backgroundColor: colors.darkGrey,
  color: colors.white,
  border: "none",
  borderRadius: "6px",
  padding: "10px 20px",
  fontSize: "14px",
  fontWeight: "600",
  cursor: disabled ? "default" : "pointer",
  opacity: disabled ? 0.6 : 1,
});

export const ghostButton = {
  background: "none",
  border: `1px solid ${colors.border}`,
  borderRadius: "6px",
  padding: "9px 16px",
  fontSize: "14px",
  cursor: "pointer",
  color: colors.text,
};

export const muted = {
  fontSize: "13px",
  color: colors.slate,
};

export const errorText = {
  color: colors.red,
  fontSize: "13px",
  marginTop: "10px",
};

export const emptyState = {
  padding: "40px",
  textAlign: "center",
  color: "#94a3b8",
  fontSize: "14px",
  lineHeight: "1.6",
};
